export class Mutex {
    promise = Promise.resolve();
    andThen(fn) {
        this.promise = this.promise.then(() => fn(), () => fn());
        return this.promise;
    }
}
export function compact(obj) {
    const value = {};
    for (const key in obj) {
        if (obj[key] !== null) {
            value[key] = obj[key];
        }
        else {
            value[key] = undefined;
        }
    }
    return value;
}
/**
 * Reference counting helper for managing resource lifecycle
 */
export class Rc {
    count = 0;
    disposeFn;
    constructor(disposeFn) {
        this.disposeFn = disposeFn;
    }
    inc() {
        this.count++;
    }
    async dec() {
        this.count--;
        if (this.count === 0 && this.disposeFn) {
            await this.disposeFn();
        }
    }
    getCount() {
        return this.count;
    }
}
//# sourceMappingURL=util.js.map